module.exports = __webpack_public_path__ + "img/merge-dots.dfe60224.svg";